import React from "react";
import { Col, Card, CardBody, Table, Row } from "reactstrap";
import PropTypes from 'prop-types';

//Simple bar
import SimpleBar from "simplebar-react";

//Import Images
import img1 from "../../assets/images/companies/img-1.png";
import img2 from "../../assets/images/companies/img-2.png";
import img3 from "../../assets/images/companies/img-3.png";
import { formatDate } from "helpers/backend_helper";
import { Link } from "react-router-dom";

const BirthdaysReports = (props) => {
  const reports = [
    {
      'type': 'Payslip',
      'link':'#'
    },
    {
      'type': 'RBS',
      'link':'#'
    },
    {
      'type': 'NSSF',
      'link':'#'
    },
    {
      'type': 'PAYE',
      'link':'#'
    }];

  return (
    <React.Fragment>
      <Col xl="12">
        <Card>
          <CardBody>
          <h4 className="card-title text-primary mdi mdi-cake-variant mb-4">{" "} Birthdays</h4>
          <SimpleBar style={{ maxHeight: "370px" }}>
              <ul className="list-group">
                {props.birthdays && props.birthdays.map((b,k)=>(
                  <li key={k}>{b.BirthdayText}</li>
                ))}
              </ul>
          </SimpleBar>
          </CardBody>
        </Card>
        {(props.showReports == true) && (
        <Card className="bg-success bg-soft">
        <div>
          <Row>
            <Col xs="12">
              <div className="text-primary p-3">
              <h4 className="card-title text-primary mdi mdi-file-download-outline mb-4">{" "} Reports</h4>
                <ul className="ps-3 mb-0">
                {reports && reports.map((l,k)=>(
                  <li className="py-1" key={k}><Link to="#">{l.type}</Link></li>
                ))}
                 
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
      )}
      </Col>
      
    </React.Fragment>
  );
};
BirthdaysReports.propTypes = {
  approvals: PropTypes.any,
  birthdays: PropTypes.any,
  showReports: PropTypes.any
};
export default BirthdaysReports;
